import { toTitleCase } from "../../../../Utils/stringUtls";
import { currencies } from "../../GeneralInformation/ContractAndPaymentTerms";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { formatReviewDate } from "../reviewSummaryUtils";

const ContractAndPaymentTerms = ({ data, type = "debit" }) => {
  let data1 = data?.["1_1"];
    data1 = data?.["0_1"];
  const {
    cpt_contract_status,
    cpt_expiryDate,
    cpt_setupCost,
    cpt_setupCostCurrency,
    cpt_minStartDate,
    cpt_additional_information,
    cpt_payment_terms,
    cpt_type_of_i2c_pricing,
  } = data1;

  const currencyValue =
    currencies?.find((curr) => curr.label === cpt_setupCostCurrency)?.value ??
    cpt_setupCostCurrency ??
    "";

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <ReviewSummarySectionHeading title="Contract and Payment Terms" />
        <ReviewAttribute
          label="Contact Status"
          value={cpt_contract_status ? toTitleCase(cpt_contract_status) : null}
        />
        <ReviewAttribute label="Expiry Date" value={formatReviewDate(cpt_expiryDate)} />
        <ReviewAttribute
          label={`Setup Cost${currencyValue ? ` (${currencyValue})` : ""}`}
          value={cpt_setupCost}
        />
        <ReviewAttribute
          label="Monthly Minimum Start Date"
          value={formatReviewDate(cpt_minStartDate)}
        />
        <ReviewAttribute
          label="Payment Terms"
          value={cpt_payment_terms ? toTitleCase(cpt_payment_terms) : null}
        />

        <ReviewAttribute
          label="Type of i2c Inc. Pricing Selected"
          value={
            cpt_type_of_i2c_pricing
              ? toTitleCase(cpt_type_of_i2c_pricing)
              : null
          }
        />
        <ReviewAttribute
          label="Additional Information"
          fullWidth
          value={
            cpt_additional_information
              ? toTitleCase(cpt_additional_information)
              : null
          }
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default ContractAndPaymentTerms;
